import axios from "axios";

export const cancelRequest = axios.CancelToken.source();
const host = process.env.VUE_APP_BASE_URL;
import { getCookie, delCookie } from "@/util/cookies";

export const _axios = axios.create({
  baseURL: host,
  headers: { "Content-Type": "application/json" }
});

// Add a request interceptor
_axios.interceptors.request.use(
  function (config) {
    const token = getCookie("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

_axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (
      error.response.data.statusCode === 401 &&
      error.response.data.error === "Token is not valid/expired."
    ) {
      delCookie("token");
      delete _axios.defaults.headers.common["Authorization"];
      window.location.replace("https://portal.htop.stechoq.com/auth/login");
    }
    return Promise.reject(error);
  }
);
export default {
  install(Vue, options) {
    Vue.prototype.$api = _axios;
  }
};
